import React, { useState } from "react";
import Section from "./Section";
import axios from "axios";
import { toast } from "react-toastify";
import Banner from "./Banner";

export default function Application({ isBanner = false, title = "İletişim" }) {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basit validasyon
    if (!formData.fullName || !formData.email || !formData.message) {
      toast.error("Lütfen zorunlu alanları doldurun.");
      return;
    }

    setLoading(true);
    try {
      await axios.post("https://api.aidatplus.com/api/contact", formData); // Backend endpoint
      toast.success("Mesajınız başarıyla gönderildi!");
      setFormData({ fullName: "", email: "", phone: "", message: "" });
    } catch (err) {
      toast.error("Mesaj gönderilemedi. Lütfen tekrar deneyin.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {isBanner ? <Banner title={title} /> : null}
      <Section id="contact" className="ud-contact">
        <div className="row align-items-center">
          <div className="col-xl-8 col-lg-7">
            <div className="ud-contact-content-wrapper">
              <div className="ud-contact-title">
                <span>BİZE ULAŞIN</span>
                <h2>
                  Mesajınızı iletin <br /> Sizinle iletişime geçmek isteriz!
                </h2>
              </div>

              <div className="ud-contact-info-wrapper">
                <div className="ud-single-info">
                  <div className="ud-info-icon">
                    <i className="lni lni-map-marker"></i>
                  </div>
                  <div className="ud-info-meta">
                    <h5>Adresimiz</h5>
                    <p>Niğde, Türkiye</p>
                  </div>
                </div>

                <div className="ud-single-info">
                  <div className="ud-info-icon">
                    <i className="lni lni-envelope"></i>
                  </div>
                  <div className="ud-info-meta">
                    <h5>İletişim E-posta</h5>
                    <p>contactoixobt@gmail.com</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-4 col-lg-5">
            <div
              className="ud-contact-form-wrapper wow fadeInUp"
              data-wow-delay=".2s"
            >
              <h3 className="ud-contact-form-title">Mesaj Gönder</h3>
              <form className="ud-contact-form" onSubmit={handleSubmit}>
                <div className="ud-form-group">
                  <label htmlFor="fullName">Ad Soyad*</label>
                  <input
                    type="text"
                    name="fullName"
                    placeholder="Örn: Ahmet Yılmaz"
                    value={formData.fullName}
                    onChange={handleChange}
                  />
                </div>

                <div className="ud-form-group">
                  <label htmlFor="email">Email*</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="example@domain.com"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>

                <div className="ud-form-group">
                  <label htmlFor="phone">Telefon</label>
                  <input
                    type="text"
                    name="phone"
                    placeholder="+90 555 123 45 67"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>

                <div className="ud-form-group">
                  <label htmlFor="message">Mesaj*</label>
                  <textarea
                    name="message"
                    rows="4"
                    placeholder="Mesajınızı buraya yazın"
                    value={formData.message}
                    onChange={handleChange}
                  ></textarea>
                </div>

                <div className="ud-form-group mb-0">
                  <button
                    type="submit"
                    className="ud-main-btn"
                    disabled={loading}
                  >
                    {loading ? "Gönderiliyor..." : "Gönder"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Section>
    </>
  );
}
